import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  tabIconWrapper: {
 alignSelf: 'center', justifyContent: 'center', alignItems: 'center', marginVertical: scale(8) 
  },
});

export default styles;

